import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wf-credit",
  "use": "wf-credit-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 160 160\" id=\"wf-credit\"><path d=\"M80 0C35.8 0 0 35.8 0 80s35.8 80 80 80 80-35.8 80-80S124.2 0 80 0zm24.8 129.2L74.6 92.3l-8.5 10.1v26.8H45.5V30.8h20.6v41.7l34.8-41.7h25.5L87.5 77l43 52.2h-25.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol